/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Journey_LinkedInputs */



/**
* | output |
* | --- |
* | "Meeting linked" |
*
* @param {Journey_LinkedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const journey_linked = /** @type {((inputs?: Journey_LinkedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Journey_LinkedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprek gekoppeld")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rendez-vous associé")
	return /** @type {LocalizedString} */ ("Meeting linked")
});